/**
 * Api Portal AutoAtendimento
 * AutoAtendimento
 *
 * OpenAPI spec version: v1
 * Contact: helpdesk@sicred.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';

/**
* The ContratosView model module.
* @module model/ContratosView
* @version v1
*/
export default class ContratosView {
    /**
    * Constructs a new <code>ContratosView</code>.
    * @alias module:model/ContratosView
    * @class
    */

    constructor() { }

    /**
    * Constructs a <code>ContratosView</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ContratosView} obj Optional instance to populate.
    * @return {module:model/ContratosView} The populated <code>ContratosView</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContratosView();

            if (Object.prototype.hasOwnProperty.call(data, 'agencia')) {
                obj['agencia'] = ApiClient.convertToType(data['agencia'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'empresa')) {
                obj['empresa'] = ApiClient.convertToType(data['empresa'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'numeroContrato')) {
                obj['numeroContrato'] = ApiClient.convertToType(data['numeroContrato'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'cliente')) {
                obj['cliente'] = ApiClient.convertToType(data['cliente'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'descricao')) {
                obj['descricao'] = ApiClient.convertToType(data['descricao'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'produto')) {
                obj['produto'] = ApiClient.convertToType(data['produto'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'valorFinanciado')) {
                obj['valorFinanciado'] = ApiClient.convertToType(data['valorFinanciado'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'saldoDevedor')) {
                obj['saldoDevedor'] = ApiClient.convertToType(data['saldoDevedor'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'emissao')) {
                obj['emissao'] = ApiClient.convertToType(data['emissao'], 'Date');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'situacao')) {
                obj['situacao'] = ApiClient.convertToType(data['situacao'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'tipoCobranca')) {
                obj['tipoCobranca'] = ApiClient.convertToType(data['tipoCobranca'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'qtdParcelasPagas')) {
                obj['qtdParcelasPagas'] = ApiClient.convertToType(data['qtdParcelasPagas'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'qtdParcelas')) {
                obj['qtdParcelas'] = ApiClient.convertToType(data['qtdParcelas'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'primeiroVencimento')) {
                obj['primeiroVencimento'] = ApiClient.convertToType(data['primeiroVencimento'], 'Date');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'ultimoPagamento')) {
                obj['ultimoPagamento'] = ApiClient.convertToType(data['ultimoPagamento'], 'Date');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'proximaParcela')) {
                obj['proximaParcela'] = ApiClient.convertToType(data['proximaParcela'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'proximoVencimento')) {
                obj['proximoVencimento'] = ApiClient.convertToType(data['proximoVencimento'], 'Date');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'ultimoVencimento')) {
                obj['ultimoVencimento'] = ApiClient.convertToType(data['ultimoVencimento'], 'Date');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'dataContrato')) {
                obj['dataContrato'] = ApiClient.convertToType(data['dataContrato'], 'Date');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'extrato')) {
                obj['extrato'] = ApiClient.convertToType(data['extrato'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'declaracao')) {
                obj['declaracao'] = ApiClient.convertToType(data['declaracao'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'direcionamento')) {
                obj['direcionamento'] = ApiClient.convertToType(data['direcionamento'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeExtrato')) {
                obj['exibeExtrato'] = ApiClient.convertToType(data['exibeExtrato'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeDeclaracao')) {
                obj['exibeDeclaracao'] = ApiClient.convertToType(data['exibeDeclaracao'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeSeguro')) {
                obj['exibeSeguro'] = ApiClient.convertToType(data['exibeSeguro'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeSecuritizado')) {
                obj['exibeSecuritizado'] = !ApiClient.convertToType(data['exibeSecuritizado'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'securitizado')) {
                obj['securitizado'] = ApiClient.convertToType(data['securitizado'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'lojista')) {
                obj['lojista'] = ApiClient.convertToType(data['lojista'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeSegundaVia')) {
                obj['exibeSegundaVia'] = ApiClient.convertToType(data['exibeSegundaVia'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'reneg')) {
                obj['reneg'] = ApiClient.convertToType(data['reneg'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeReneg')) {
                obj['exibeReneg'] = ApiClient.convertToType(data['exibeReneg'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'exibeLiquidadoCessao')) {
                obj['exibeLiquidadoCessao'] = ApiClient.convertToType(data['exibeLiquidadoCessao'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'liquidadoCessao')) {
                obj['liquidadoCessao'] = ApiClient.convertToType(data['liquidadoCessao'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'contratoCdi')) {
                obj['contratoCdi'] = ApiClient.convertToType(data['contratoCdi'], 'Boolean');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'emiteCarne')) {
                obj['emiteCarne'] = ApiClient.convertToType(data['emiteCarne'], 'Boolean');
            }
        }
        return obj;
    }

    /**
    * @member {String} agencia
    */
    agencia = undefined;
    /**
    * @member {String} empresa
    */
    empresa = undefined;
    /**
    * @member {String} numeroContrato
    */
    numeroContrato = undefined;
    /**
    * @member {String} cliente
    */
    cliente = undefined;
    /**
    * @member {String} descricao
    */
    descricao = undefined;
    /**
    * @member {String} produto
    */
    produto = undefined;
    /**
    * @member {Number} valorFinanciado
    */
    valorFinanciado = undefined;
    /**
    * @member {Number} saldoDevedor
    */
    saldoDevedor = undefined;
    /**
    * @member {Date} emissao
    */
    emissao = undefined;
    /**
    * @member {String} situacao
    */
    situacao = undefined;
    /**
    * @member {String} tipoCobranca
    */
    tipoCobranca = undefined;
    /**
    * @member {Number} qtdParcelasPagas
    */
    qtdParcelasPagas = undefined;
    /**
    * @member {Number} qtdParcelas
    */
    qtdParcelas = undefined;
    /**
    * @member {Date} primeiroVencimento
    */
    primeiroVencimento = undefined;
    /**
    * @member {Date} ultimoPagamento
    */
    ultimoPagamento = undefined;
    /**
    * @member {String} proximaParcela
    */
    proximaParcela = undefined;
    /**
    * @member {Date} proximoVencimento
    */
    proximoVencimento = undefined;
    /**
    * @member {Date} ultimoVencimento
    */
    ultimoVencimento = undefined;
    /**
    * @member {Date} dataContrato
    */
    dataContrato = undefined;
    /**
    * @member {String} extrato
    */
    extrato = undefined;
    /**
    * @member {String} declaracao
    */
    declaracao = undefined;
    /**
    * @member {String} direcionamento
    */
    direcionamento = undefined;
    /**
    * @member {Boolean} exibeExtrato
    */
    exibeExtrato = undefined;
    /**
    * @member {Boolean} exibeDeclaracao
    */
    exibeDeclaracao = undefined;
    /**
    * @member {Boolean} exibeSeguro
    */
    exibeSeguro = undefined;
    /**
    * @member {String} securitizado
    */
    securitizado = undefined;
    /**
    * @member {Boolean} exibeSecuritizado
    */
    exibeSecuritizado = undefined;
    /**
    * @member {String} lojista
    */
    lojista = undefined;
    /**
    * @member {Boolean} exibeSegundaVia
    */
    exibeSegundaVia = undefined;
    /**
    * @member {String} reneg
    */
    reneg = undefined;
    /**
    * @member {Boolean} exibeReneg
    */
    exibeReneg = undefined;
    /**
    * @member {String} liquidadoCessao
    */
    liquidadoCessao = undefined;
    /**
    * @member {Boolean} exibeLiquidadoCessao
    */
    exibeLiquidadoCessao = undefined;
    /**
    * @member {Boolean} contratoCdi
    */
    contratoCdi = undefined;


    

}


